import type { Socket } from 'socket.io-client';

type TypeListener = (...args: any[]) => void;

export type TypeTrackedSocket = { socket: Socket; release: () => void };

export const socketListenerTracker = (socket: Socket): TypeTrackedSocket => {
    const added: [string, TypeListener][] = [];

    const tracked: Socket = new Proxy(socket, {
        get(target, property) {
            if (property === 'on') {
                return (event: string, listener: TypeListener) => {
                    added.push([event, listener]);
                    target.on(event, listener);
                    return tracked;
                };
            }
            const value = Reflect.get(target, property, target);
            return typeof value === 'function' ? value.bind(target) : value;
        },
    });

    const release = () => {
        for (const [event, listener] of added.splice(0)) socket.off(event, listener);
    };

    return { socket: tracked, release };
};

export default socketListenerTracker;
